// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.usage-dialog {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 1.25rem 1.35rem 1.15rem;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.usage-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 1rem;
  margin-bottom: 0.85rem;
  flex-shrink: 0;
}
.usage-header .eyebrow {
  margin: 0;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #64748b;
  font-weight: 600;
}
.usage-header h2 {
  margin: 0.2rem 0 0;
  font-size: 1.35rem;
  color: #0f172a;
}

.usage-scroll {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 0.25rem;
  margin-right: -0.15rem;
}
.usage-scroll::-webkit-scrollbar {
  width: 6px;
}
.usage-scroll::-webkit-scrollbar-track {
  background: rgba(94, 161, 216, 0.12);
  border-radius: 999px;
}
.usage-scroll::-webkit-scrollbar-thumb {
  background: #5ea1d8;
  border-radius: 999px;
}

.usage-alerts {
  display: grid;
  gap: 0.5rem;
  margin-bottom: 1rem;
}

.usage-alert {
  padding: 0.65rem 0.75rem;
  border-radius: 8px;
  background: rgba(94, 161, 216, 0.12);
  color: #1d4f7a;
  font-size: 0.875rem;
  line-height: 1.4;
}
.usage-alert.warning, .usage-alert.exceeded {
  background: rgba(232, 62, 140, 0.1);
  color: #a0165a;
}

.close-btn {
  border: none;
  background: rgba(94, 161, 216, 0.12);
  border-radius: 999px;
  width: 36px;
  height: 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #1d4f7a;
}

.usage-body {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding-bottom: 0.25rem;
}

.muted {
  color: #64748b;
  margin: 0;
}

.plan-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem 0.75rem;
  align-items: center;
}

.status-pill {
  display: inline-flex;
  padding: 0.2rem 0.65rem;
  border-radius: 999px;
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  background: #f1f5f9;
  color: #64748b;
}
.status-pill.active {
  background: rgba(94, 161, 216, 0.14);
  color: #1d4f7a;
}

.meta-item {
  font-size: 0.85rem;
  color: #64748b;
}

.metrics {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.65rem;
}

.metric-row {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  padding: 0.7rem 0.75rem;
  border-radius: 10px;
  border: 1px solid rgba(94, 161, 216, 0.22);
  background: #fff;
  border-left: 3px solid #5ea1d8;
  min-width: 0;
  /* Near limit / exceeded use Flowchest pink */
}
.metric-row .metric-icon {
  background: rgba(94, 161, 216, 0.14);
  color: #1d4f7a;
}
.metric-row .metric-status {
  color: #1d4f7a;
  background: rgba(94, 161, 216, 0.12);
}
.metric-row .meter-fill {
  background: #5ea1d8;
}
.metric-row.level-warn, .metric-row.level-critical {
  border-left-color: #e83e8c;
  border-color: rgba(232, 62, 140, 0.22);
  background: rgba(232, 62, 140, 0.04);
}
.metric-row.level-warn .metric-icon, .metric-row.level-critical .metric-icon {
  background: rgba(232, 62, 140, 0.12);
  color: #a0165a;
}
.metric-row.level-warn .metric-status, .metric-row.level-critical .metric-status {
  color: #a0165a;
  background: rgba(232, 62, 140, 0.12);
}
.metric-row.level-warn .meter-fill, .metric-row.level-critical .meter-fill {
  background: #e83e8c;
}
.metric-row.level-ok, .metric-row.level-unlimited, .metric-row.level-info {
  border-left-color: #5ea1d8;
  background: rgba(94, 161, 216, 0.04);
}

.metric-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.4rem;
}

.metric-icon {
  width: 26px;
  height: 26px;
  border-radius: 7px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #f1f5f9;
  color: #64748b;
  flex-shrink: 0;
}
.metric-icon mat-icon {
  font-size: 15px;
  width: 15px;
  height: 15px;
  line-height: 15px;
}

.metric-label {
  margin: 0;
  font-weight: 600;
  color: #0f172a;
  font-size: 0.8rem;
  line-height: 1.25;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.metric-value {
  display: inline-flex;
  align-items: baseline;
  gap: 0.3rem;
  color: #0f172a;
}
.metric-value strong {
  font-size: 1.2rem;
  font-weight: 700;
  line-height: 1;
}

.metric-hint {
  font-size: 0.7rem;
  font-weight: 500;
  color: #64748b;
  text-transform: lowercase;
}

.metric-secondary {
  margin: 0;
  font-size: 0.68rem;
  line-height: 1.3;
  color: #64748b;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.metric-status {
  display: inline-flex;
  align-items: center;
  padding: 0.1rem 0.4rem;
  border-radius: 999px;
  font-size: 0.6rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  background: #f1f5f9;
  color: #64748b;
  white-space: nowrap;
  max-width: 80px;
  overflow: hidden;
  text-overflow: ellipsis;
  flex-shrink: 0;
}

.meter {
  height: 4px;
  border-radius: 999px;
  background: #e2e8f0;
  overflow: hidden;
  margin-top: 0.1rem;
}

.meter-fill {
  height: 100%;
  border-radius: inherit;
  background: #5ea1d8;
  transition: width 0.25s ease;
}

@media (max-width: 420px) {
  .metrics {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 640px) {
  .usage-dialog {
    padding: 1rem 0.9rem calc(0.9rem + env(safe-area-inset-bottom, 0px));
  }
  .usage-header {
    gap: 0.65rem;
    margin-bottom: 0.7rem;
  }
  .usage-header h2 {
    font-size: 1.15rem;
  }
  .close-btn {
    width: 32px;
    height: 32px;
  }
  .metrics {
    grid-template-columns: 1fr;
    gap: 0.55rem;
  }
  .actions {
    flex-direction: column-reverse;
    align-items: stretch;
    gap: 0.55rem;
    margin-top: 0.75rem;
    padding-top: 0.75rem;
  }
  .primary-btn,
  .outline-btn {
    width: 100%;
    min-height: 44px;
    justify-content: center;
    text-align: center;
  }
}
.actions {
  display: flex;
  gap: 0.75rem;
  justify-content: flex-end;
  flex-wrap: wrap;
  flex-shrink: 0;
  margin-top: 0.85rem;
  padding-top: 0.85rem;
  border-top: 1px solid #e2e8f0;
}

.primary-btn,
.outline-btn {
  border-radius: 8px;
  padding: 0.55rem 1rem;
  font-weight: 600;
  cursor: pointer;
  border: 1px solid transparent;
}

.primary-btn {
  background: #5ea1d8;
  color: #fff;
}

.outline-btn {
  background: #fff;
  border-color: #5ea1d8;
  color: #1d4f7a;
}
.outline-btn.danger {
  border-color: #fca5a5;
  color: #b91c1c;
}

/* Dark mode — subscription usage modal */
:host-context(body.theme-dark) .usage-dialog {
  background: #111827 !important;
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .usage-header .eyebrow,
:host-context(body.theme-dark) .muted,
:host-context(body.theme-dark) .meta-item,
:host-context(body.theme-dark) .metric-hint,
:host-context(body.theme-dark) .metric-secondary {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .usage-header h2,
:host-context(body.theme-dark) .metric-label,
:host-context(body.theme-dark) .metric-value {
  color: #f8fafc !important;
}
:host-context(body.theme-dark) .close-btn {
  background: rgba(94, 161, 216, 0.18) !important;
  color: #93c5fd !important;
}
:host-context(body.theme-dark) .close-btn mat-icon,
:host-context(body.theme-dark) .close-btn .mat-icon {
  color: #93c5fd !important;
}
:host-context(body.theme-dark) .status-pill {
  background: #1f2937 !important;
  color: #cbd5e1 !important;
}
:host-context(body.theme-dark) .status-pill.active {
  background: rgba(94, 161, 216, 0.2) !important;
  color: #93c5fd !important;
}
:host-context(body.theme-dark) .usage-alert {
  background: rgba(94, 161, 216, 0.14) !important;
  color: #93c5fd !important;
}
:host-context(body.theme-dark) .usage-alert.warning, :host-context(body.theme-dark) .usage-alert.exceeded {
  background: rgba(232, 62, 140, 0.16) !important;
  color: #f9a8d4 !important;
}
:host-context(body.theme-dark) .metric-row {
  background: #1f2937 !important;
  border-color: rgba(94, 161, 216, 0.28) !important;
}
:host-context(body.theme-dark) .metric-row.level-ok, :host-context(body.theme-dark) .metric-row.level-unlimited, :host-context(body.theme-dark) .metric-row.level-info {
  background: rgba(94, 161, 216, 0.1) !important;
}
:host-context(body.theme-dark) .metric-row.level-warn, :host-context(body.theme-dark) .metric-row.level-critical {
  background: rgba(232, 62, 140, 0.1) !important;
  border-color: rgba(232, 62, 140, 0.3) !important;
}
:host-context(body.theme-dark) .metric-row.level-warn .metric-icon, :host-context(body.theme-dark) .metric-row.level-critical .metric-icon {
  background: rgba(232, 62, 140, 0.18) !important;
  color: #f9a8d4 !important;
}
:host-context(body.theme-dark) .metric-row.level-warn .metric-status, :host-context(body.theme-dark) .metric-row.level-critical .metric-status {
  color: #f9a8d4 !important;
  background: rgba(232, 62, 140, 0.18) !important;
}
:host-context(body.theme-dark) .meter {
  background: #374151 !important;
}
:host-context(body.theme-dark) .usage-scroll::-webkit-scrollbar-track {
  background: rgba(94, 161, 216, 0.12);
}
:host-context(body.theme-dark) .usage-scroll::-webkit-scrollbar-thumb {
  background: #5ea1d8;
}
:host-context(body.theme-dark) .actions {
  border-top-color: rgba(148, 163, 184, 0.28) !important;
}
:host-context(body.theme-dark) .outline-btn {
  background: transparent !important;
  border-color: #5ea1d8 !important;
  color: #93c5fd !important;
}
:host-context(body.theme-dark) .primary-btn {
  color: #ffffff !important;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/subscription-usage-dialog/subscription-usage-dialog.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,gCAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AAEF;;AACA;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,SAAA;EACA,sBAAA;EACA,cAAA;AAEF;AAAE;EACE,SAAA;EACA,kBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;EACA,gBAAA;AAEJ;AACE;EACE,kBAAA;EACA,kBAAA;EACA,cAAA;AACJ;;AAGA;EACE,cAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,sBAAA;AAAF;AAEE;EACE,UAAA;AAAJ;AAGE;EACE,oCAAA;EACA,oBAAA;AADJ;AAIE;EACE,mBAAA;EACA,oBAAA;AAFJ;;AAMA;EACE,aAAA;EACA,WAAA;EACA,mBAAA;AAHF;;AAMA;EACE,wBAAA;EACA,kBAAA;EACA,oCAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;AAHF;AAKE;EAEE,mCAAA;EACA,cAAA;AAJJ;;AAQA;EACE,YAAA;EACA,oCAAA;EACA,oBAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,cAAA;AALF;;AAQA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,uBAAA;AALF;;AAQA;EACE,cAAA;EACA,SAAA;AALF;;AAQA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAAA;AALF;;AAQA;EACE,oBAAA;EACA,uBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;AALF;AAOE;EACE,oCAAA;EACA,cAAA;AALJ;;AASA;EACE,kBAAA;EACA,cAAA;AANF;;AASA;EACE,aAAA;EACA,gDAAA;EACA,YAAA;AANF;;AASA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,0CAAA;EACA,gBAAA;EACA,8BAAA;EACA,YAAA;EAgBA,6CAAA;AArBF;AAOE;EACE,oCAAA;EACA,cAAA;AALJ;AAQE;EACE,cAAA;EACA,oCAAA;AANJ;AASE;EACE,mBAAA;AAPJ;AAWE;EAEE,0BAAA;EACA,sCAAA;EACA,oCAAA;AAVJ;AAYI;EACE,oCAAA;EACA,cAAA;AAVN;AAaI;EACE,cAAA;EACA,oCAAA;AAXN;AAcI;EACE,mBAAA;AAZN;AAgBE;EAGE,0BAAA;EACA,oCAAA;AAhBJ;;AAoBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;AAjBF;;AAoBA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,cAAA;AAjBF;AAmBE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AAjBJ;;AAqBA;EACE,SAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAlBF;;AAqBA;EACE,oBAAA;EACA,qBAAA;EACA,WAAA;EACA,cAAA;AAlBF;AAoBE;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;AAlBJ;;AAsBA;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;AAnBF;;AAsBA;EACE,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAnBF;;AAsBA;EACE,oBAAA;EACA,mBAAA;EACA,sBAAA;EACA,oBAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,cAAA;AAnBF;;AAsBA;EACE,WAAA;EACA,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;AAnBF;;AAsBA;EACE,YAAA;EACA,sBAAA;EACA,mBAAA;EACA,4BAAA;AAnBF;;AAsBA;EACE;IACE,0BAAA;EAnBF;AACF;AAsBA;EACE;IACE,oEAAA;EApBF;EAuBA;IACE,YAAA;IACA,qBAAA;EArBF;EAuBE;IACE,kBAAA;EArBJ;EAyBA;IACE,WAAA;IACA,YAAA;EAvBF;EA0BA;IACE,0BAAA;IACA,YAAA;EAxBF;EA2BA;IACE,8BAAA;IACA,oBAAA;IACA,YAAA;IACA,mBAAA;IACA,oBAAA;EAzBF;EA4BA;;IAEE,WAAA;IACA,gBAAA;IACA,uBAAA;IACA,kBAAA;EA1BF;AACF;AA6BA;EACE,aAAA;EACA,YAAA;EACA,yBAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,oBAAA;EACA,6BAAA;AA3BF;;AA8BA;;EAEE,kBAAA;EACA,qBAAA;EACA,gBAAA;EACA,eAAA;EACA,6BAAA;AA3BF;;AA8BA;EACE,mBAAA;EACA,WAAA;AA3BF;;AA8BA;EACE,gBAAA;EACA,qBAAA;EACA,cAAA;AA3BF;AA6BE;EACE,qBAAA;EACA,cAAA;AA3BJ;;AA+BA,yCAAA;AAEE;EACE,8BAAA;EACA,yBAAA;AA7BJ;AAgCE;;;;;EAKE,yBAAA;AA9BJ;AAiCE;;;EAGE,yBAAA;AA/BJ;AAkCE;EACE,+CAAA;EACA,yBAAA;AAhCJ;AAkCI;;EAEE,yBAAA;AAhCN;AAoCE;EACE,8BAAA;EACA,yBAAA;AAlCJ;AAoCI;EACE,8CAAA;EACA,yBAAA;AAlCN;AAsCE;EACE,+CAAA;EACA,yBAAA;AApCJ;AAsCI;EAEE,+CAAA;EACA,yBAAA;AArCN;AAyCE;EACE,8BAAA;EACA,iDAAA;AAvCJ;AAyCI;EAGE,8CAAA;AAzCN;AA4CI;EAEE,8CAAA;EACA,gDAAA;AA3CN;AA6CM;EACE,+CAAA;EACA,yBAAA;AA3CR;AA8CM;EACE,yBAAA;EACA,+CAAA;AA5CR;AAiDE;EACE,8BAAA;AA/CJ;AAmDI;EACE,oCAAA;AAjDN;AAoDI;EACE,mBAAA;AAlDN;AAsDE;EACE,sDAAA;AApDJ;AAuDE;EACE,kCAAA;EACA,gCAAA;EACA,yBAAA;AArDJ;AAwDE;EACE,yBAAA;AAtDJ","sourcesContent":[".usage-dialog {\n  width: 100%;\n  height: 100%;\n  box-sizing: border-box;\n  padding: 1.25rem 1.35rem 1.15rem;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.usage-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 1rem;\n  margin-bottom: 0.85rem;\n  flex-shrink: 0;\n\n  .eyebrow {\n    margin: 0;\n    font-size: 0.75rem;\n    text-transform: uppercase;\n    letter-spacing: 0.06em;\n    color: #64748b;\n    font-weight: 600;\n  }\n\n  h2 {\n    margin: 0.2rem 0 0;\n    font-size: 1.35rem;\n    color: #0f172a;\n  }\n}\n\n.usage-scroll {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding-right: 0.25rem;\n  margin-right: -0.15rem;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(94, 161, 216, 0.12);\n    border-radius: 999px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: #5ea1d8;\n    border-radius: 999px;\n  }\n}\n\n.usage-alerts {\n  display: grid;\n  gap: 0.5rem;\n  margin-bottom: 1rem;\n}\n\n.usage-alert {\n  padding: 0.65rem 0.75rem;\n  border-radius: 8px;\n  background: rgba(94, 161, 216, 0.12);\n  color: #1d4f7a;\n  font-size: 0.875rem;\n  line-height: 1.4;\n\n  &.warning,\n  &.exceeded {\n    background: rgba(232, 62, 140, 0.1);\n    color: #a0165a;\n  }\n}\n\n.close-btn {\n  border: none;\n  background: rgba(94, 161, 216, 0.12);\n  border-radius: 999px;\n  width: 36px;\n  height: 36px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: #1d4f7a;\n}\n\n.usage-body {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  padding-bottom: 0.25rem;\n}\n\n.muted {\n  color: #64748b;\n  margin: 0;\n}\n\n.plan-meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem 0.75rem;\n  align-items: center;\n}\n\n.status-pill {\n  display: inline-flex;\n  padding: 0.2rem 0.65rem;\n  border-radius: 999px;\n  font-size: 0.75rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  background: #f1f5f9;\n  color: #64748b;\n\n  &.active {\n    background: rgba(94, 161, 216, 0.14);\n    color: #1d4f7a;\n  }\n}\n\n.meta-item {\n  font-size: 0.85rem;\n  color: #64748b;\n}\n\n.metrics {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 0.65rem;\n}\n\n.metric-row {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  padding: 0.7rem 0.75rem;\n  border-radius: 10px;\n  border: 1px solid rgba(94, 161, 216, 0.22);\n  background: #fff;\n  border-left: 3px solid #5ea1d8;\n  min-width: 0;\n\n  .metric-icon {\n    background: rgba(94, 161, 216, 0.14);\n    color: #1d4f7a;\n  }\n\n  .metric-status {\n    color: #1d4f7a;\n    background: rgba(94, 161, 216, 0.12);\n  }\n\n  .meter-fill {\n    background: #5ea1d8;\n  }\n\n  /* Near limit / exceeded use Flowchest pink */\n  &.level-warn,\n  &.level-critical {\n    border-left-color: #e83e8c;\n    border-color: rgba(232, 62, 140, 0.22);\n    background: rgba(232, 62, 140, 0.04);\n\n    .metric-icon {\n      background: rgba(232, 62, 140, 0.12);\n      color: #a0165a;\n    }\n\n    .metric-status {\n      color: #a0165a;\n      background: rgba(232, 62, 140, 0.12);\n    }\n\n    .meter-fill {\n      background: #e83e8c;\n    }\n  }\n\n  &.level-ok,\n  &.level-unlimited,\n  &.level-info {\n    border-left-color: #5ea1d8;\n    background: rgba(94, 161, 216, 0.04);\n  }\n}\n\n.metric-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.4rem;\n}\n\n.metric-icon {\n  width: 26px;\n  height: 26px;\n  border-radius: 7px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: #f1f5f9;\n  color: #64748b;\n  flex-shrink: 0;\n\n  mat-icon {\n    font-size: 15px;\n    width: 15px;\n    height: 15px;\n    line-height: 15px;\n  }\n}\n\n.metric-label {\n  margin: 0;\n  font-weight: 600;\n  color: #0f172a;\n  font-size: 0.8rem;\n  line-height: 1.25;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.metric-value {\n  display: inline-flex;\n  align-items: baseline;\n  gap: 0.3rem;\n  color: #0f172a;\n\n  strong {\n    font-size: 1.2rem;\n    font-weight: 700;\n    line-height: 1;\n  }\n}\n\n.metric-hint {\n  font-size: 0.7rem;\n  font-weight: 500;\n  color: #64748b;\n  text-transform: lowercase;\n}\n\n.metric-secondary {\n  margin: 0;\n  font-size: 0.68rem;\n  line-height: 1.3;\n  color: #64748b;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.metric-status {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.1rem 0.4rem;\n  border-radius: 999px;\n  font-size: 0.6rem;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n  background: #f1f5f9;\n  color: #64748b;\n  white-space: nowrap;\n  max-width: 80px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  flex-shrink: 0;\n}\n\n.meter {\n  height: 4px;\n  border-radius: 999px;\n  background: #e2e8f0;\n  overflow: hidden;\n  margin-top: 0.1rem;\n}\n\n.meter-fill {\n  height: 100%;\n  border-radius: inherit;\n  background: #5ea1d8;\n  transition: width 0.25s ease;\n}\n\n@media (max-width: 420px) {\n  .metrics {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 640px) {\n  .usage-dialog {\n    padding: 1rem 0.9rem calc(0.9rem + env(safe-area-inset-bottom, 0px));\n  }\n\n  .usage-header {\n    gap: 0.65rem;\n    margin-bottom: 0.7rem;\n\n    h2 {\n      font-size: 1.15rem;\n    }\n  }\n\n  .close-btn {\n    width: 32px;\n    height: 32px;\n  }\n\n  .metrics {\n    grid-template-columns: 1fr;\n    gap: 0.55rem;\n  }\n\n  .actions {\n    flex-direction: column-reverse;\n    align-items: stretch;\n    gap: 0.55rem;\n    margin-top: 0.75rem;\n    padding-top: 0.75rem;\n  }\n\n  .primary-btn,\n  .outline-btn {\n    width: 100%;\n    min-height: 44px;\n    justify-content: center;\n    text-align: center;\n  }\n}\n\n.actions {\n  display: flex;\n  gap: 0.75rem;\n  justify-content: flex-end;\n  flex-wrap: wrap;\n  flex-shrink: 0;\n  margin-top: 0.85rem;\n  padding-top: 0.85rem;\n  border-top: 1px solid #e2e8f0;\n}\n\n.primary-btn,\n.outline-btn {\n  border-radius: 8px;\n  padding: 0.55rem 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  border: 1px solid transparent;\n}\n\n.primary-btn {\n  background: #5ea1d8;\n  color: #fff;\n}\n\n.outline-btn {\n  background: #fff;\n  border-color: #5ea1d8;\n  color: #1d4f7a;\n\n  &.danger {\n    border-color: #fca5a5;\n    color: #b91c1c;\n  }\n}\n\n/* Dark mode — subscription usage modal */\n:host-context(body.theme-dark) {\n  .usage-dialog {\n    background: #111827 !important;\n    color: #e2e8f0 !important;\n  }\n\n  .usage-header .eyebrow,\n  .muted,\n  .meta-item,\n  .metric-hint,\n  .metric-secondary {\n    color: #94a3b8 !important;\n  }\n\n  .usage-header h2,\n  .metric-label,\n  .metric-value {\n    color: #f8fafc !important;\n  }\n\n  .close-btn {\n    background: rgba(94, 161, 216, 0.18) !important;\n    color: #93c5fd !important;\n\n    mat-icon,\n    .mat-icon {\n      color: #93c5fd !important;\n    }\n  }\n\n  .status-pill {\n    background: #1f2937 !important;\n    color: #cbd5e1 !important;\n\n    &.active {\n      background: rgba(94, 161, 216, 0.2) !important;\n      color: #93c5fd !important;\n    }\n  }\n\n  .usage-alert {\n    background: rgba(94, 161, 216, 0.14) !important;\n    color: #93c5fd !important;\n\n    &.warning,\n    &.exceeded {\n      background: rgba(232, 62, 140, 0.16) !important;\n      color: #f9a8d4 !important;\n    }\n  }\n\n  .metric-row {\n    background: #1f2937 !important;\n    border-color: rgba(94, 161, 216, 0.28) !important;\n\n    &.level-ok,\n    &.level-unlimited,\n    &.level-info {\n      background: rgba(94, 161, 216, 0.1) !important;\n    }\n\n    &.level-warn,\n    &.level-critical {\n      background: rgba(232, 62, 140, 0.1) !important;\n      border-color: rgba(232, 62, 140, 0.3) !important;\n\n      .metric-icon {\n        background: rgba(232, 62, 140, 0.18) !important;\n        color: #f9a8d4 !important;\n      }\n\n      .metric-status {\n        color: #f9a8d4 !important;\n        background: rgba(232, 62, 140, 0.18) !important;\n      }\n    }\n  }\n\n  .meter {\n    background: #374151 !important;\n  }\n\n  .usage-scroll {\n    &::-webkit-scrollbar-track {\n      background: rgba(94, 161, 216, 0.12);\n    }\n\n    &::-webkit-scrollbar-thumb {\n      background: #5ea1d8;\n    }\n  }\n\n  .actions {\n    border-top-color: rgba(148, 163, 184, 0.28) !important;\n  }\n\n  .outline-btn {\n    background: transparent !important;\n    border-color: #5ea1d8 !important;\n    color: #93c5fd !important;\n  }\n\n  .primary-btn {\n    color: #ffffff !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
